import React, { Component } from "react"
import ReactApexChart from "react-apexcharts"

class LeadPiechart extends Component {
  constructor(props) {
    super(props)
  
    this.state = {
      series: [20, 20, 20, 20, 20],
      options: {
        labels: ["RSVP", "Google Ads", "Facebook", "Website","Open House"],
        colors:['#66C2A5', '#FFD92F','#A6D854','#E78AC3','#92A5D2'],
        legend: {
          show: true,
          position: "bottom",
          horizontalAlign: "center",
          verticalAlign: "middle",
          floating: false,
          fontSize: "14px",
          offsetX: 0,
          offsetY: -10,
        },
       
      },
    }
  }
  render() {
    return (
      <React.Fragment>
        <ReactApexChart
          options={this.state.options}
          series={this.state.series}
          type="pie"
          height="350"
          className="apex-charts"
        />
      </React.Fragment>
    )
  }
}

export default LeadPiechart
